import { render } from "./InputWysiwyg.vue?vue&type=template&id=71f02360"
import script from "./InputWysiwyg.vue?vue&type=script&lang=js"
export * from "./InputWysiwyg.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__